import { jsx as _jsx } from "react/jsx-runtime";
import NetworkAvatar from "./NetworkAvatar.js";
const NetworkBadge = ({ network, AvatarProps = {}, }) => (_jsx(NetworkAvatar, { network: network, AvatarProps: {
        ...AvatarProps,
        sx: {
            // TODO(KK): why pixels?
            width: "32px",
            height: "32px",
            borderRadius: 0.4,
            fontSize: "1.2rem",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.25)",
            objectFit: "contain",
            ...AvatarProps.sx,
        },
    }, forceNetworkBackgroundColor: true }));
export default NetworkBadge;
